import { Component, Input } from '@angular/core';
import { SurveyData } from '../shared/survey.interface';

@Component({
  selector: 'ps-ui-cpi-card',
  templateUrl: './cpi-card.component.html',
  styleUrls: ['./cpi-card.component.scss'],
})
export class CpiCardComponent {
  @Input() content!: SurveyData;
  @Input() userRole: string;
}
